module.exports = __webpack_public_path__ + "23a3afb68699dd24544ddb03b3c8087e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MZ.svg
// module id = eddg
// module chunks = 0